import React from 'react';

import { Box, Card, Stack, Typography } from '@mui/material';

import { ResourceInfoFragment } from 'src/api';
import { SxProp } from 'src/types/mui';

import { ResourceCardIcon } from './ResourceCardIcon';
import { ResourceLink } from './ResourceLink';

interface ResourceCardProps {
  resource: ResourceInfoFragment;
}

export const ResourceCard: React.FC<ResourceCardProps> = ({
  resource: { url, file, iconName, title, description, originType },
}) => (
  <ResourceLink url={url || file?.downloadUrl || ''} originType={originType}>
    <Card sx={cardStyles}>
      <Stack direction="row" spacing={3}>
        <ResourceCardIcon iconName={iconName} />
        <Box>
          <Typography fontWeight={500}>{title}</Typography>
          <Typography variant="body2" mt={1}>
            {description}
          </Typography>
        </Box>
      </Stack>
    </Card>
  </ResourceLink>
);

const cardStyles: SxProp = {
  p: 3,
  borderRadius: '10px',
  height: '100%',
  boxShadow: '0px 4px 40px rgba(0, 0, 0, 0.05)',
  '&:hover': {
    boxShadow: '0px 4px 40px rgba(0, 0, 0, 0.1)',
  },
};
